import { useEffect, useState } from "react";
import { server } from "../../server";
import axios from "axios";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

function ComplainBox() {
  const [complainBoxDetails, setComplainBoxDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const recordsPerPage = 10;

  const fetchComplainBoxDetails = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${server}/complainBox_alldata_mongodb`,
        {
          headers: { Authorization: `${localStorage.getItem("token")}` },
        }
      );
      const responseData = response.data?.["body-json"]?.body?.data;

      if (Array.isArray(responseData)) {
        const sortedData = [...responseData].sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        setComplainBoxDetails(sortedData);
      } else {
        console.error("Invalid data format from API", response.data);
      }
    } catch (error) {
      console.error("Error fetching fee details:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchComplainBoxDetails();
  }, []);

  const updateComplainStatus = async (complain, status) => {
    Swal.fire({
      title: `Are you sure?`,
      text: `You are about to mark this complaint as "${status}".`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor:
        status === "Solved"
          ? "#28a745"
          : status === "Under Review"
          ? "#17a2b8"
          : "#d33",
      cancelButtonColor: "#6c757d",
      confirmButtonText: `Yes, mark as ${status}!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await fetch(`${server}/update_complain_mongodb`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `${localStorage.getItem("token")}`,
            },
            body: JSON.stringify({
              complainId: complain.complainId,
              complainType: complain.complainType,
              name: complain.name,
              phoneNo: complain.phoneNo,
              date: new Date(complain.createdAt).toLocaleDateString("en-GB"),
              complainDescription: complain.complainDescription,
              status: status,
            }),
          });

          const data = await response.json();
          if (response.ok) {
            toast.success(`Complaint Marked as ${status}`);
            fetchComplainBoxDetails();
          } else {
            toast.error(data?.message || "Update failed");
          }
        } catch (error) {
          console.error("Error updating complaint:", error);
          toast.error("Please Try Again");
        }
      }
    });
  };

  // Filter
  const filteredRecords = complainBoxDetails.filter((ComplainBox) => {
    const searchLower = searchTerm.toLowerCase();

    return Object.values(ComplainBox || {}).some(
      (value) =>
        typeof value === "string" && value.toLowerCase().includes(searchLower)
    );
  });

  // Calculate pagination
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredRecords.slice(
    indexOfFirstRecord,
    indexOfLastRecord
  );
  const totalPages = Math.ceil(filteredRecords.length / recordsPerPage);

  // Page Navigation
  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return (
    <>
      <div id="db-wrapper">
        <main id="page-content">
          <div class="container-fluid my-3 px-3">
            <div className="row g-2">
              <div className="col-lg-8">
                <div class="table-responsive border-0 overflow-y-hidden bg-white rounded-4">
                  <table class="table mb-0 text-nowrap table-centered">
                    <thead class="table-light">
                      <tr>
                        <th className="w-10">No.</th>
                        <th className="lh-1 w-60">
                          Details
                          <i className="bi bi-info-circle ms-2 text-dark"></i>
                          <br />
                          <span className="fs-8 fw-normal text-secondary">
                            Displaying Information as per Record
                          </span>
                        </th>
                        <th className="lh-1 w-30">
                          Action
                          <i className="bi bi-person-gear ms-2 text-dark"></i>
                          <br />
                          <span className="fs-8 fw-normal text-secondary">
                            Role-Specific Action Panel
                          </span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentRecords.map((complain, index) => (
                        <tr key={index}>
                          <td>{indexOfFirstRecord + index + 1}.</td>
                          <td className="lh-sm py-4 text-wrap">
                            <span class="text-dark">Complain ID</span> &mdash;{" "}
                            {complain.complainId}
                            <br />
                            <span class="text-dark">Date</span> &mdash;{" "}
                            <span className="text-uppercase">
                              {new Date(complain.createdAt).toLocaleString(
                                "en-GB",
                                {
                                  day: "2-digit",
                                  month: "2-digit",
                                  year: "numeric",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  hour12: true,
                                }
                              )}
                            </span>
                            <br />
                            <span class="text-dark">Complaint Type</span>{" "}
                            &mdash; {complain.complainType}
                            <br />
                            <span class="text-dark">
                              Admission No
                            </span> &mdash; {complain.admission_no}
                            <br />
                            <span class="text-dark">Name</span> &mdash;{" "}
                            <span className="text-capitalize">
                              {complain.name}
                            </span>
                            <br />
                            <span class="text-dark">Phone No</span> &mdash;{" "}
                            {complain.phoneNo}
                            <br />
                            <span class="text-dark">Complaint</span> &mdash;
                            <br />
                            {complain?.complainDescription
                              .split(" ")
                              .map(
                                (word) =>
                                  word.charAt(0).toUpperCase() +
                                  word.slice(1).toLowerCase()
                              )
                              .reduce((acc, word, index, arr) => {
                                const isHindi = /[\u0900-\u097F]/.test(
                                  arr.join(" ")
                                );
                                const groupSize = isHindi ? 10 : 8;
                                const last = acc.length - 1;
                                if (index % groupSize === 0) {
                                  acc.push([word]);
                                } else {
                                  acc[last].push(word);
                                }
                                return acc;
                              }, [])
                              .map((group, i) => (
                                <span key={i}>
                                  {group.join(" ")}
                                  <br />
                                </span>
                              ))}
                            <br />
                            <span class="text-dark">Status</span> &mdash;{" "}
                            {complain.status ? (
                              <span
                                className={
                                  complain.status === "Solved"
                                    ? "text-success"
                                    : complain.status === "Under Review"
                                    ? "text-info"
                                    : complain.status === "Declined"
                                    ? "text-danger"
                                    : complain.status === "Pending"
                                    ? "text-warning"
                                    : "text-secondary"
                                }
                              >
                                {complain.status}
                              </span>
                            ) : (
                              <span className="text-secondary">Pending</span>
                            )}
                          </td>
                          <td>
                            <div className="d-flex flex-column gap-1 width-fit-content">
                              {/* ✅ Pending — show all buttons active */}
                              {(complain.status === "Pending" ||
                                !complain.status) && (
                                <>
                                  <span
                                    className="badge bg-success-soft cursor-pointer px-4 rounded-3 btn-py-sm"
                                    onClick={() =>
                                      updateComplainStatus(complain, "Solved")
                                    }
                                  >
                                    Solved
                                  </span>
                                  <span
                                    className="badge bg-info-soft cursor-pointer px-4 rounded-3 btn-py-sm"
                                    onClick={() =>
                                      updateComplainStatus(
                                        complain,
                                        "Under Review"
                                      )
                                    }
                                  >
                                    Under Review
                                  </span>
                                  <span className="badge bg-dark-soft cursor-pointer px-4 rounded-3 btn-py-sm">
                                    Follow Up
                                  </span>
                                  <div className="d-flex justify-content-center">
                                    <hr className="w-50" />
                                  </div>
                                  <span
                                    className="badge bg-danger-soft cursor-pointer px-4 rounded-3 btn-py-sm"
                                    onClick={() =>
                                      updateComplainStatus(complain, "Declined")
                                    }
                                  >
                                    Declined
                                  </span>
                                </>
                              )}

                              {/* ✅ Solved — show only Solved (disabled) */}
                              {complain.status === "Solved" && (
                                <span className="badge bg-success-soft px-4 rounded-3">
                                  Solved
                                </span>
                              )}

                              {/* ✅ Under Review — show all, only Under Review disabled */}
                              {complain.status === "Under Review" && (
                                <>
                                  <span
                                    className="badge bg-success-soft cursor-pointer px-4 rounded-3 btn-py-sm"
                                    onClick={() =>
                                      updateComplainStatus(complain, "Solved")
                                    }
                                  >
                                    Solved
                                  </span>
                                  <span className="badge bg-info-soft px-4 rounded-3">
                                    Under Review
                                  </span>
                                  <span className="badge bg-dark-soft cursor-pointer px-4 rounded-3 btn-py-sm">
                                    Follow Up
                                  </span>
                                  <div className="d-flex justify-content-center">
                                    <hr className="w-50" />
                                  </div>
                                  <span
                                    className="badge bg-danger-soft cursor-pointer px-4 rounded-3 btn-py-sm"
                                    onClick={() =>
                                      updateComplainStatus(complain, "Declined")
                                    }
                                  >
                                    Declined
                                  </span>
                                </>
                              )}

                              {/* ✅ Declined — show only Declined (disabled) */}
                              {complain.status === "Declined" && (
                                <span className="badge bg-danger-soft px-4 rounded-3">
                                  Declined
                                </span>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="col-lg-4">
                <div class="">
                  <div className="mb-3">
                    <div className="bg-white rounded-pill">
                      <form
                        className="d-flex align-items-center"
                        onSubmit={(e) => e.preventDefault()}
                      >
                        <span className="position-absolute ps-3 search-icon">
                          <i className="bi bi-filter-circle-fill ms-1" />
                        </span>
                        <input
                          type="search"
                          className="form-control ps-7 rounded-3 border-0 rounded-4"
                          placeholder="Filter Data"
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                        />
                      </form>
                    </div>
                    <div className="mt-2 ms-4">
                      <nav aria-label="breadcrumb">
                        <ol class="breadcrumb pe-3">
                          <li class="breadcrumb-item">
                            <a href="#">Manage Administrator</a>
                          </li>
                          <li
                            class="breadcrumb-item active"
                            aria-current="page"
                          >
                            Complain Box
                          </li>
                        </ol>
                      </nav>
                    </div>
                  </div>

                  <div className="p-4 bg-white rounded-4">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="d-flex align-items-center">
                        {loading ? (
                          <div
                            className="spinner-border text-dark data-loader-spinner"
                            role="status"
                          ></div>
                        ) : (
                          <img src="/assets/images/folder.svg" />
                        )}

                        <p className="my-0 fw-semibold lh-1 fs-5 text-dark mx-3">
                          Complain Box
                          <br />
                          <span className="text-secondary fs-6 fw-medium lh-sm">
                            0.2 MB Size
                          </span>
                        </p>
                      </div>
                      <span className="badge bg-pink rounded-3 px-4 py-2 me-1 mt-1 cursor-pointer">
                        Export
                      </span>
                    </div>

                    <div class="px-4 py-2 mt-3 bg-light rounded-4">
                      <li className="list-group-item px-0">
                        <a
                          className="d-flex align-items-center text-inherit mb-0 justify-content-between"
                          data-bs-toggle="collapse"
                          href="#specifications"
                          role="button"
                          aria-expanded="false"
                          aria-controls="specifications"
                        >
                          <p className="m-0 fw-medium lh-sm text-dark">
                            Download Report
                          </p>
                          <span className="chevron-arrow ms-4">
                            <i className="bi bi-chevron-down fs-4" />
                          </span>
                        </a>
                        <div
                          className="collapse"
                          id="specifications"
                          data-bs-parent="#ecommerceAccordion"
                        >
                          <div className="py-3">
                            <div class="rounded-4 d-flex flex-wrap">
                              <span class="btn btn-outline-primary btn-sm px-4 rounded-3 mb-1 me-1">
                                Complain Report
                              </span>
                              <span class="btn btn-outline-primary btn-sm px-4 rounded-3 mb-1 me-1">
                                Today's Complain Report
                              </span>
                              <span class="btn btn-outline-primary btn-sm px-4 rounded-3 mb-1 me-1">
                                Complaint Type Wise Report
                              </span>
                              <span class="btn btn-outline-primary btn-sm px-4 rounded-3 mb-1 me-1">
                                Complain Box (PDF) Report
                              </span>
                            </div>
                          </div>
                        </div>
                      </li>
                    </div>
                  </div>

                  <div className="my-4">
                    <nav>
                      <ul className="pagination justify-content-center mb-0">
                        <li
                          className={`page-item ${
                            currentPage === 1 ? "disabled" : ""
                          }`}
                        >
                          <button className="page-link" onClick={prevPage}>
                            <i className="bi bi-chevron-left"></i>
                          </button>
                        </li>

                        {(() => {
                          const pageNumbers = [];
                          pageNumbers.push(1);

                          if (currentPage > 3) {
                            pageNumbers.push("left-ellipsis");
                          }

                          if (currentPage !== 1 && currentPage !== totalPages) {
                            pageNumbers.push(currentPage);
                          }

                          if (currentPage < totalPages - 2) {
                            pageNumbers.push("right-ellipsis");
                          }

                          if (totalPages > 1) {
                            pageNumbers.push(totalPages);
                          }

                          return pageNumbers.map((page, index) => {
                            if (
                              page === "left-ellipsis" ||
                              page === "right-ellipsis"
                            ) {
                              return (
                                <li key={index} className="page-item disabled">
                                  <span className="page-link">...</span>
                                </li>
                              );
                            }

                            return (
                              <li
                                key={index}
                                className={`page-item ${
                                  currentPage === page ? "active" : ""
                                }`}
                              >
                                <button
                                  className="page-link"
                                  onClick={() => setCurrentPage(page)}
                                >
                                  {page}
                                </button>
                              </li>
                            );
                          });
                        })()}

                        <li
                          className={`page-item ${
                            currentPage === totalPages ? "disabled" : ""
                          }`}
                        >
                          <button className="page-link" onClick={nextPage}>
                            <i className="bi bi-chevron-right"></i>
                          </button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
}

export default ComplainBox;
